import { DestroyRef, inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export type AppVersionData = {
  version: string;
  date: string;
};

@Injectable({
  providedIn: 'root',
})
export class AppVersionService {
  private appVersionData = new BehaviorSubject<AppVersionData | null>(null);
  private readonly destroyRef = inject(DestroyRef);
  private readonly http = inject(HttpClient);

  loadVersion(): Observable<AppVersionData> {
    return this.http
      .get<{ version: string; versionDate: string }>('/assets/app-version.json')
      .pipe(
        map(response => {
          const newData = {
            version: response.version,
            date: response.versionDate,
          };

          this.appVersionData.next(newData);

          return newData;
        }),
        takeUntilDestroyed(this.destroyRef),
      );
  }

  get appVersionData$(): Observable<AppVersionData | null> {
    return this.appVersionData.asObservable();
  }
}
